import { render, staticRenderFns } from "./management_group.vue?vue&type=template&id=2e756d88&"
import script from "./management_group.vue?vue&type=script&lang=js&"
export * from "./management_group.vue?vue&type=script&lang=js&"
import style0 from "./management_group.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports